module.exports = __webpack_public_path__ + "img/mouse_banner.afa1ea3d.png";